<template>
  <nav class="Navigation">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless-mobile">
          <router-link class="Navigation-logo" to="/">
            <div class="Logo"></div>
          </router-link>
          <router-link class="Navigation-link" :class="{'is-selected' : ($route.name === 'Politikken')}" to="/politikken">Politikken</router-link>
          <router-link class="Navigation-link" :class="{'is-selected' : ($route.name === 'Organisasjonen')}" to="/organisasjonen">Organisasjonen</router-link>
          <router-link class="Navigation-link is-red is-hidden-tablet is-marginless" to="/bli-medlem">Bli medlem</router-link>
          <router-link class="Button is-red is-outline is-hidden-mobile NavMem" to="/bli-medlem">Bli medlem </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'navbar'
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue